import {Injectable, TemplateRef} from '@angular/core';
import {MatDialog} from '@angular/material';
import {ComponentType} from '@angular/cdk/portal';
import {ConfigInterface} from './ConfigInterface';
import {ModalDialog} from '../ModalDialog';

@Injectable()
export class Factory {

    private matDialog: MatDialog = null;

    // ########################################

    constructor(
        matDialog: MatDialog
    ) {
        this.matDialog = matDialog;
    }

    // ########################################

    public create(componentOrTemplateRef: ComponentType<any> | TemplateRef<any>, dialogConfig: ConfigInterface): ModalDialog {
        return new ModalDialog(this.matDialog, componentOrTemplateRef, dialogConfig);
    }

    // ########################################
}
